/* @pareto-engineering/generator-front 1.1.1-alpha.2 */
import * as React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { FieldArray, useFormikContext } from 'formik';
import styleNames from '@pareto-engineering/bem/exports';
import { ChoicesInput, SelectInput, TextInput, integerAndGreaterThanZero, fileUploadOptions } from "../../../../../../f";
import { ToggleSwitch } from "../../../../../../a";
import "./styles.scss";

// Local Definitions

import { ActionsContainer } from "../ActionsContainer";
const baseClassName = styleNames.base;
const componentClassName = 'input-builder';
const getToggleSwitchStyles = condition => condition ? {
  '--slider-background-color': 'var(--disabled)'
} : {};

/**
 * This is the component description.
 */
const InputBuilder = ({
  id,
  className: userClassName,
  style,
  sectionIndex,
  inputIndex,
  onDelete
  // onCopy,
  // ...otherProps
}) => {
  const {
    values,
    setFieldValue
  } = useFormikContext();
  const input = values.sections[sectionIndex]?.inputs[inputIndex];
  const handleToggleRequired = () => {
    setFieldValue(`sections.${sectionIndex}.inputs.${inputIndex}.required`, !input?.required);
  };
  const [hasDescription, setHasDescription] = useState(false);

  // TODO: handle nav logic
  // const handleToggleConditionalNavigation = () => {
  //   setFieldValue(`sections.${sectionIndex}.inputs.${inputIndex}.conditionalNavigation`,
  // !input?.conditionalNavigation)
  // }

  const availableSections = values?.sections?.map((section, idx) => ({
    value: idx,
    label: `Go to ${section.title || `Untitled Section ${idx + 1}`}`
  }));
  const shouldRenderOptions = input?.type === 'select' || input?.type === 'multiple' || input?.type === 'choices';
  const handleSelectOptionBlur = (e, optionIndex) => {
    const {
      value
    } = e.target;
    setFieldValue(`sections.${sectionIndex}.inputs.${inputIndex}.options.${optionIndex}.label`, value);
  };
  const isFile = input?.type === 'file';
  const handleToggleShowSpecificFileTypes = () => {
    setFieldValue(`sections.${sectionIndex}.inputs.${inputIndex}.showSpecificFileTypes`, !input.showSpecificFileTypes);
  };
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "drag-icon"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ai-icon"
  }, "H")), /*#__PURE__*/React.createElement("div", {
    className: "input-options-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "controls-container"
  }, /*#__PURE__*/React.createElement(SelectInput, {
    name: `sections.${sectionIndex}.inputs.${inputIndex}.type`,
    options: [{
      value: '',
      label: 'Select an option',
      disabled: true
    }, {
      value: 'text',
      label: 'Basic input'
    }, {
      value: 'number',
      label: 'Number input'
    }, {
      value: 'textarea',
      label: 'Long paragraph'
    }, {
      value: 'select',
      label: 'Dropdown select'
    }, {
      value: 'multiple',
      label: 'Checkboxes'
    }, {
      value: 'choices',
      label: 'Radio buttons'
    }, {
      value: 'file',
      label: 'File upload'
    }]
  }), /*#__PURE__*/React.createElement("div", {
    className: "controls"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => onDelete(inputIndex)
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon x-ui-icons c-x"
  }, "D")), /*#__PURE__*/React.createElement("div", {
    className: "is-required"
  }, /*#__PURE__*/React.createElement("span", {
    className: "s0"
  }, "Required"), /*#__PURE__*/React.createElement(ToggleSwitch, {
    handleOnChange: handleToggleRequired,
    checked: input?.required,
    style: getToggleSwitchStyles(!input?.required),
    inputId: `sections_${sectionIndex}_inputs.${inputIndex}_toggle`
  })), /*#__PURE__*/React.createElement(ActionsContainer, null, /*#__PURE__*/React.createElement("p", null, "Show"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", {
    className: `option ${hasDescription ? 'with-check-mark' : ''}`
  }, hasDescription && /*#__PURE__*/React.createElement("span", {
    className: "x-ui-icons c-x icon"
  }, "I"), /*#__PURE__*/React.createElement("button", {
    onClick: () => setHasDescription(!hasDescription),
    type: "button"
  }, "Description")))))), /*#__PURE__*/React.createElement("div", {
    className: "input-name-description"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Input name",
    name: `sections.${sectionIndex}.inputs.${inputIndex}.label`,
    placeholder: "Question"
  }), hasDescription && /*#__PURE__*/React.createElement(TextInput, {
    label: "Description (optional)",
    name: `sections.${sectionIndex}.inputs.${inputIndex}.description`,
    placeholder: "Describe details for the question"
  })), shouldRenderOptions && /*#__PURE__*/React.createElement(FieldArray, {
    name: `sections.${sectionIndex}.inputs.${inputIndex}.options`
  }, ({
    push,
    remove
  }) => /*#__PURE__*/React.createElement("div", {
    className: "input-options"
  }, /*#__PURE__*/React.createElement("p", null, "Options"), input?.options.map((option, optionIndex) => /*#__PURE__*/React.createElement("div", {
    key: option.key,
    className: "option-container"
  }, input?.type !== 'select' && /*#__PURE__*/React.createElement("div", {
    className: `input-icon-sample ${input?.type}`
  }), /*#__PURE__*/React.createElement(TextInput, {
    name: `sections.${sectionIndex}.inputs.${inputIndex}.options.${optionIndex}.value`,
    placeholder: `Option ${optionIndex + 1}`,
    onBlur: e => handleSelectOptionBlur(e, optionIndex)
  }), input?.conditionalNavigation && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectInput, {
    options: [{
      label: 'Select section',
      value: '',
      disabled: true
    }, ...availableSections],
    name: `sections.${sectionIndex}.inputs.${inputIndex}.options.${optionIndex}.nextSection`
  })), /*#__PURE__*/React.createElement("button", {
    className: "icon",
    type: "button",
    onClick: () => remove(optionIndex)
  }, "Y"))), /*#__PURE__*/React.createElement("button", {
    className: "add-option-cta",
    type: "button",
    onClick: () => push({
      key: `sections-${sectionIndex}-inputs-${inputIndex}-options-${input?.options.length - 1}`,
      value: '',
      label: '',
      nextSection: ''
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "icon-container"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon"
  }, "+")), /*#__PURE__*/React.createElement("span", {
    className: "text x-paragraph c-x"
  }, "Add Option")))), isFile && /*#__PURE__*/React.createElement("div", {
    className: "input-file-options"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Maximum number of files",
    name: `sections.${sectionIndex}.inputs.${inputIndex}.maxCount`,
    placeholder: "1",
    type: "number",
    min: "0",
    validate: integerAndGreaterThanZero
  }), /*#__PURE__*/React.createElement("div", {
    className: "specific-file-types"
  }, /*#__PURE__*/React.createElement(ToggleSwitch, {
    handleOnChange: handleToggleShowSpecificFileTypes,
    checked: input?.showSpecificFileTypes,
    style: getToggleSwitchStyles(!input?.showSpecificFileTypes),
    inputId: `sections_${sectionIndex}_inputs.${inputIndex}_show_specific_file_types`
  }), /*#__PURE__*/React.createElement("span", {
    className: "s0"
  }, "Allow only specific file types")), input?.showSpecificFileTypes && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChoicesInput, {
    name: `sections.${sectionIndex}.inputs.${inputIndex}.accept`,
    options: fileUploadOptions,
    multiple: true
  })))));
};
InputBuilder.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string)
};
InputBuilder.defaultProps = {
  // some properties
};
export default InputBuilder;